import React, { useEffect, useRef, useState } from "react";
import Appstore from "../../assets/icons/appstore.webp";
import Google from "../../assets/icons/googleplay.webp";
import "./footer.scss";
import { useNavigate } from "react-router-dom";
import SvgYoutube from "../../icons/SvgYoutube";
import SvgInsta from "../../icons/SvgInsta";
import SvgFB from "../../icons/SvgFB";
import SvgLinkedIn from "../../icons/SvgLinkedIn";
import SvgTwitter from "../../icons/SvgTwitter";
import SvgThread from "../../icons/SvgThread";
import { useDispatch } from "react-redux";
import { socialLinksMiddleWare } from "../../pages/terms-and-privacy/store/privacypolicyMiddleware";
import { isEmpty } from "../../utils/validators";

const Footer = ({ handleReset }) => {
  const dispatch = useDispatch();
  const [data, setData] = useState(null);
  const navigate = useNavigate();
  const isDispatched = useRef(false);
  const currentYear = new Date().getFullYear();
  useEffect(() => {
    if (!isDispatched.current && isEmpty(data)) {
      dispatch(socialLinksMiddleWare()).then((res) => {
        if (Array.isArray(res.payload?.data) && res.payload?.data?.length > 0) {
          setData(res.payload?.data[0]);
        }
      });
      isDispatched.current = true;
    }
  }, []);
  return (
    <>
      <div className="footer-container">
        <div className="left-col">
          <div className="get-touch">
            <div className="top-section">
              <h3 className={"get-touch-text"}>Get In Touch</h3>
              <p>
                Connect with an Astrologer for personalized future predictions.
                Guidance is just a click away, crafted for your needs
              </p>
            </div>
            <div className="social_icons">
              <a href={data?.facebook} target="_blank" rel="noreferrer">
                <SvgFB />
              </a>
              <a href={data?.instagram} target="_blank" rel="noreferrer">
                <SvgInsta />
              </a>
              <a href={data?.linkedIn} target="_blank" rel="noreferrer">
                <SvgLinkedIn />
              </a>
              <a href={data?.youtube} target="_blank" rel="noreferrer">
                <SvgYoutube />
              </a>
              <a href={data?.twitter} target="_blank" rel="noreferrer">
                <SvgTwitter />
              </a>
              <a href={data?.threads} target="_blank" rel="noreferrer">
                <SvgThread />
              </a>
            </div>
          </div>
          <div className="bottom-section mobile-bottom">
            <h3>Download Now</h3>
            <div className="img-container">
              {" "}
              <img
                style={{ cursor: "pointer" }}
                onClick={() =>
                  (window.location.href =
                    "https://astrocure.co.in/coming-soon/")
                }
                src={Appstore}
                alt="coming"
              />
              <img
                src={Google}
                alt="Google"
                onClick={() =>
                  (window.location.href =
                    "https://play.google.com/store/apps/details?id=com.astrocure")
                }
              />
            </div>
          </div>
        </div>
        <div className="left-section">
          <h3>Company info</h3>
          <ul>
            <li
              onClick={() => {
                navigate("/about");
              }}
            >
              About Us
            </li>
            <li
              onClick={() => {
                navigate("/contact-us");
              }}
            >
              Contact Us
            </li>

            <li
              onClick={() => {
                navigate("/privacy-policy");
              }}
            >
              Privacy Policy
            </li>
            <li
              onClick={() => {
                navigate("/terms-and-conditions");
              }}
            >
              Terms and Conditions
            </li>
            <li
              onClick={() => {
                navigate("/refund-policy");
              }}
            >
              Refund Policy
            </li>
          </ul>
        </div>
        <div className="right-section">
          <h3>Services</h3>
          <ul>
            <li
              onClick={() => {
                navigate("/horoscope");
              }}
            >
              Horoscope
            </li>
            <li
              onClick={() => {
                navigate("/videos");
                if (handleReset) {
                  handleReset();
                }
              }}
            >
              Prediction Videos{" "}
            </li>
            <li style={{ color: "transparent", cursor: "auto" }}>
              Prediction Videos{" "}
            </li>
          </ul>
          <div className="bottom-section desktop-bottom">
            <h3 className={"download-text"}>Download Now</h3>
            <div className="img-container">
              {" "}
              <img
                style={{ cursor: "pointer" }}
                onClick={() =>
                  (window.location.href =
                    "https://astrocure.co.in/coming-soon/")
                }
                src={Appstore}
                alt="coming"
              />
              <img
                src={Google}
                alt="Google"
                onClick={() =>
                  (window.location.href =
                    "https://play.google.com/store/apps/details?id=com.astrocure")
                }
              />
            </div>
          </div>
        </div>
      </div>
      <p className="copyright">
        Copyright {currentYear} Astrovidhi Private Limited All Rights Reserved
      </p>
    </>
  );
};

export default Footer;
